'use client';

import { c as _c } from "react/compiler-runtime";
import ListAlt from '@mui/icons-material/ListAlt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ChecklistIcon from '@mui/icons-material/Checklist';
import Source from '@mui/icons-material/Source';
import Warehouse from '@mui/icons-material/Warehouse';
import OilBarrel from '@mui/icons-material/OilBarrel';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Engineering from '@mui/icons-material/Engineering';
import HubRounded from '@mui/icons-material/HubRounded';
import HomeIcon from '@mui/icons-material/Home';
import DeveloperBoardRounded from '@mui/icons-material/DeveloperBoardRounded';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import TableChartIcon from '@mui/icons-material/TableChart';
import PrecisionManufacturing from '@mui/icons-material/PrecisionManufacturingRounded';
import FolderIcon from '@mui/icons-material/Folder';
import SettingsApplications from '@mui/icons-material/SettingsApplicationsRounded';
import DvrIcon from '@mui/icons-material/Dvr';
import Work from '@mui/icons-material/WorkOutline';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Announcement from '@mui/icons-material/Announcement';
import Badge from '@mui/material/Badge';
import * as colors from '@mui/material/colors';
import { SideMenuItem } from '@/app/_components/SideMenuItem';
import { ROUTES } from '@/app/routes';
import { type FC } from 'react';
import { SideMenuGroup } from '@/app/_components/SideMenuGroup';
import { useUser } from '@/app/_shared/hooks/useUser';
import { QuestionAnswer } from '@mui/icons-material';
interface SideMenuPages {
  isMenuOpen: boolean;
}
const CommonPages: FC<SideMenuPages> = t0 => {
  const $ = _c(3);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RequestQuoteIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMenuOpen) {
    t2 = <><SideMenuItem isMenuOpen={isMenuOpen} icon={t1} route={ROUTES.opportunities.base}>Opportunity List</SideMenuItem></>;
    $[1] = isMenuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const HomePage: FC<SideMenuPages> = t0 => {
  const $ = _c(3);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HomeIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMenuOpen) {
    t2 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t1} route={ROUTES.ppt.base}>Home</SideMenuItem>;
    $[1] = isMenuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const JobPages: FC<SideMenuPages> = t0 => {
  const $ = _c(9);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Work />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMenuOpen) {
    t2 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t1} route={ROUTES.ppt.jobs}>Job List</SideMenuItem>;
    $[1] = isMenuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ListAlt />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMenuOpen) {
    t4 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t3} route={ROUTES.ppt.sheets}>PPT List</SideMenuItem>;
    $[4] = isMenuOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export const GuestPages: FC<SideMenuPages> = t0 => {
  const $ = _c(12);
  const {
    isMenuOpen
  } = t0;
  const {
    jmtAccess,
    qmtAccess
  } = useUser();
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <HomePage isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMenuOpen || $[3] !== qmtAccess) {
    t2 = qmtAccess && <CommonPages isMenuOpen={isMenuOpen} />;
    $[2] = isMenuOpen;
    $[3] = qmtAccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isMenuOpen || $[6] !== jmtAccess) {
    t3 = jmtAccess && <JobPages isMenuOpen={isMenuOpen} />;
    $[5] = isMenuOpen;
    $[6] = jmtAccess;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const UserPages: FC<SideMenuPages> = t0 => {
  const $ = _c(12);
  const {
    isMenuOpen
  } = t0;
  const {
    jmtAccess,
    qmtAccess
  } = useUser();
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <HomePage isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMenuOpen || $[3] !== qmtAccess) {
    t2 = qmtAccess && <CommonPages isMenuOpen={isMenuOpen} />;
    $[2] = isMenuOpen;
    $[3] = qmtAccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isMenuOpen || $[6] !== jmtAccess) {
    t3 = jmtAccess && <JobPages isMenuOpen={isMenuOpen} />;
    $[5] = isMenuOpen;
    $[6] = jmtAccess;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const SiteManagerPages: FC<SideMenuPages> = t0 => {
  const $ = _c(12);
  const {
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Source />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isMenuOpen) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.ppt.recipes}>Recipes</SideMenuItem>;
    $[3] = isMenuOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PrecisionManufacturing />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isMenuOpen) {
    t5 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t4} route={ROUTES.ppt.workstations}>Workstations</SideMenuItem>;
    $[6] = isMenuOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t5) {
    t6 = <>{t1}{t3}{t5}</>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export const AdminPages: FC<SideMenuPages & {
  newSuggestionsCount?: number;
}> = t0 => {
  const $ = _c(84);
  const {
    isMenuOpen,
    newSuggestionsCount
  } = t0;
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== newSuggestionsCount) {
    t2 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><AttachMoneyIcon sx={{
        color: colors.yellow[500]
      }} /></Badge> : <AttachMoneyIcon />;
    $[2] = newSuggestionsCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DvrIcon />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isMenuOpen) {
    t4 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t3} route={ROUTES.operations.base}>Operations</SideMenuItem>;
    $[5] = isMenuOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FolderIcon />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isMenuOpen) {
    t6 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t5} route={ROUTES.technologies.base}>Technologies</SideMenuItem>;
    $[8] = isMenuOpen;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SavedSearchIcon />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isMenuOpen) {
    t8 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t7} route={ROUTES.lookups.base}>Lookup Tables</SideMenuItem>;
    $[11] = isMenuOpen;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TableChartIcon />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isMenuOpen) {
    t10 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t9} route={ROUTES.dataStore.base}>Data Store</SideMenuItem>;
    $[14] = isMenuOpen;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ReceiptIcon />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isMenuOpen) {
    t12 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t11} route={ROUTES.quoteTypes.base}>Quote Types</SideMenuItem>;
    $[17] = isMenuOpen;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChecklistIcon />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== isMenuOpen) {
    t14 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t13} route={ROUTES.coreSections.base}>Core Formulas</SideMenuItem>;
    $[20] = isMenuOpen;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== newSuggestionsCount) {
    t15 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><Announcement sx={{
        color: colors.yellow[500]
      }} /></Badge> : <QuestionAnswer />;
    $[22] = newSuggestionsCount;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== isMenuOpen || $[25] !== t15) {
    t16 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t15} route={ROUTES.suggestions.base}>QMT Suggestions</SideMenuItem>;
    $[24] = isMenuOpen;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== isMenuOpen || $[28] !== t10 || $[29] !== t12 || $[30] !== t14 || $[31] !== t16 || $[32] !== t2 || $[33] !== t4 || $[34] !== t6 || $[35] !== t8) {
    t17 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t2} title="Pricing Admin">{t4}{t6}{t8}{t10}{t12}{t14}{t16}</SideMenuGroup>;
    $[27] = isMenuOpen;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t16;
    $[32] = t2;
    $[33] = t4;
    $[34] = t6;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <EngineeringIcon />;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <DeveloperBoardRounded />;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== isMenuOpen) {
    t20 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t19} route={ROUTES.ppt.operations}>Operations</SideMenuItem>;
    $[39] = isMenuOpen;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Source />;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== isMenuOpen) {
    t22 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t21} route={ROUTES.ppt.recipes}>Recipes</SideMenuItem>;
    $[42] = isMenuOpen;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <HubRounded />;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== isMenuOpen) {
    t24 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t23} route={ROUTES.ppt.coreSections}>Core Sections</SideMenuItem>;
    $[45] = isMenuOpen;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SettingsApplications />;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== isMenuOpen) {
    t26 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t25} route={ROUTES.ppt.editTemplate}>Edit PPT Template</SideMenuItem>;
    $[48] = isMenuOpen;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== isMenuOpen || $[51] !== t20 || $[52] !== t22 || $[53] !== t24 || $[54] !== t26) {
    t27 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t18} title="Job Admin">{t20}{t22}{t24}{t26}</SideMenuGroup>;
    $[50] = isMenuOpen;
    $[51] = t20;
    $[52] = t22;
    $[53] = t24;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <AssuredWorkloadIcon />;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Warehouse />;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== isMenuOpen) {
    t30 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t29} route={ROUTES.ppt.sites}>Sites</SideMenuItem>;
    $[58] = isMenuOpen;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <OilBarrel />;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== isMenuOpen) {
    t32 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t31} route={ROUTES.ppt.materials}>Materials</SideMenuItem>;
    $[61] = isMenuOpen;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Engineering />;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== isMenuOpen) {
    t34 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t33} route={ROUTES.ppt.engineers.base}>Engineers</SideMenuItem>;
    $[64] = isMenuOpen;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <PrecisionManufacturing />;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] !== isMenuOpen) {
    t36 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t35} route={ROUTES.ppt.workstations}>Workstations</SideMenuItem>;
    $[67] = isMenuOpen;
    $[68] = t36;
  } else {
    t36 = $[68];
  }
  let t37;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <QuestionAnswer />;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== isMenuOpen) {
    t38 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t37} route={ROUTES.ppt.suggestions}>JMT Suggestions</SideMenuItem>;
    $[70] = isMenuOpen;
    $[71] = t38;
  } else {
    t38 = $[71];
  }
  let t39;
  if ($[72] !== isMenuOpen || $[73] !== t30 || $[74] !== t32 || $[75] !== t34 || $[76] !== t36 || $[77] !== t38) {
    t39 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t28} title="General Admin">{t30}{t32}{t34}{t36}{t38}</SideMenuGroup>;
    $[72] = isMenuOpen;
    $[73] = t30;
    $[74] = t32;
    $[75] = t34;
    $[76] = t36;
    $[77] = t38;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t1 || $[80] !== t17 || $[81] !== t27 || $[82] !== t39) {
    t40 = <>{t1}{t17}{t27}{t39}</>;
    $[79] = t1;
    $[80] = t17;
    $[81] = t27;
    $[82] = t39;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  return t40;
};